import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { SidebarsIconTooltip } from '../Sidebar/sidebarTooltip/SidebarsIconTooltip';
import { circleColor, IconProps, strokeColor } from './icons.utils';

export const MyDealsIcon: React.FC<IconProps> = ({
  active,
  className = '',
  tooltip = '',
}: IconProps): JSX.Element => {
  const [hover, setIsHover] = useState(false);

  const location = useLocation();

  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (e: MouseEvent) => {
    const target = e.target as Node;
    const isAvatarTarget = wrapperRef.current?.contains(target);
    if (!isAvatarTarget && hover) setIsHover(false);
    else if (isAvatarTarget) setIsHover(!hover);
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () =>
      document.removeEventListener('click', handleClickOutside, true);
  });

  const onEnter = () => {
    setIsHover(true);
  };
  const onLeave = () => {
    setIsHover(false);
  };

  const isDealsPage =
    location.pathname.includes('deals') ||
    location.pathname.includes('engagements');

  const circleFill =
    hover && !active && !isDealsPage
      ? '#cdd5e5'
      : circleColor(active || isDealsPage);

  const underscore =
    active || isDealsPage ? (
      <rect
        x="3.5"
        y="21"
        width="8.34831"
        height="1.9"
        rx="1.0254"
        fill={strokeColor(active)}
      />
    ) : (
      <></>
    );
  return (
    <div
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
      className="sidebar__nav-link__icon__wrapper"
      ref={wrapperRef}
    >
      <SidebarsIconTooltip isActive={hover} label={tooltip} />
      {active || isDealsPage ? (
        <svg
          width="27"
          height="28"
          viewBox="-6 -6 29 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <circle
            cx="8"
            cy="8"
            r="14"
            fill={circleFill}
            style={
              active || isDealsPage
                ? {}
                : { transitionDuration: '0.1s', opacity: '0.2' }
            }
          />
          <rect width="16" height="16" rx="2" fill="#cdd5e5" />
          <path d="M8 4H12.5" stroke="#545C7D" strokeLinecap="round" />
          <path d="M8 8H12.5" stroke="#545C7D" strokeLinecap="round" />
          <path d="M8 12H12.5" stroke="#545C7D" strokeLinecap="round" />
          <circle cx="4" cy="4" r="1" fill="#545C7D" />
          <circle cx="4" cy="8" r="1" fill="#545C7D" />
          <circle cx="4" cy="12" r="1" fill="#545C7D" />
          {underscore}
        </svg>
      ) : (
        <svg
          width="27"
          height="28"
          viewBox="-6 -6 29 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <rect
            x="0.5"
            y="0.5"
            width="15"
            height="15"
            rx="0.5"
            stroke="#cdd5e5"
          />
          <circle
            cx="8"
            cy="8"
            r="14"
            fill={circleFill}
            style={
              active || isDealsPage
                ? {}
                : { transitionDuration: '0.1s', opacity: '0.2' }
            }
          />
          <path d="M8 4H12.5" stroke="#cdd5e5" strokeLinecap="round" />
          <path d="M8 8H12.5" stroke="#cdd5e5" strokeLinecap="round" />
          <path d="M8 12H12.5" stroke="#cdd5e5" strokeLinecap="round" />
          <circle cx="4" cy="4" r="1" fill="#cdd5e5" />
          <circle cx="4" cy="8" r="1" fill="#cdd5e5" />
          <circle cx="4" cy="12" r="1" fill="#cdd5e5" />
        </svg>
      )}
    </div>
  );
};
